module.exports = __webpack_public_path__ + "static/media/9.0932d6b7.jpg";